exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-border-box-8{position:relative;width:100%;height:100%}.dv-border-box-8 .dv-border-svg-container{position:absolute;width:100%;height:100%;left:0;top:0}.dv-border-box-8 .border-box-content{position:relative;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/borderBox8/src/main.css
// module id = 1079
// module chunks = 45